<template>
  <span>
    <v-btn
      v-if="podePlanejar"
      height="39"
      :disabled="disabled"
      class="
        ma-1
        font-weight-bold
        text-none
        btn-primary
        bg-gradient-primary
        px-6
        ms-3
      "
      @click="abrir"
    >
      <v-icon left>mdi-map-marker-plus</v-icon>Encaixar pedidos do dia
    </v-btn>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="1380"
      scrollable
      content-class="encaixe-dialog"
      aria-label="Encaixar pedidos nos roteiros do dia"
    >
      <v-card class="encaixe crud-form-modal-card">
        <div class="encaixe__cabecalho">
          <div class="encaixe__titulo">
            <div class="crud-form-heading__icon" aria-hidden="true">
              <v-icon color="#5e72e4">mdi-map-marker-plus-outline</v-icon>
            </div>
            <div>
              <span class="encaixe__rotulo"
                >ROTEIROS DO DIA · {{ dataFormatada }}</span
              >
              <h2>Encaixar pedidos nos roteiros do dia</h2>
              <p>
                Selecione os pedidos, revise os encaixes e confirme quando
                estiver tudo pronto.
              </p>
            </div>
          </div>
          <v-btn
            icon
            :disabled="confirmando"
            aria-label="Fechar encaixe de pedidos"
            @click="fechar"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <div class="encaixe__etapas" aria-label="Etapas do encaixe">
          <span
            :class="{ 'encaixe__etapa--ativa': etapa === 'SELECAO' }"
            :aria-current="etapa === 'SELECAO' ? 'step' : null"
            ><b>1</b> Selecionar pedidos</span
          >
          <v-icon small>mdi-chevron-right</v-icon>
          <span
            :class="{
              'encaixe__etapa--ativa':
                etapa === 'REVISAO' && !confirmacaoConcluida,
            }"
            :aria-current="
              etapa === 'REVISAO' && !confirmacaoConcluida ? 'step' : null
            "
            ><b>2</b> Revisar encaixes</span
          >
          <v-icon small>mdi-chevron-right</v-icon>
          <span
            :class="{ 'encaixe__etapa--ativa': confirmacaoConcluida }"
            :aria-current="confirmacaoConcluida ? 'step' : null"
            ><b>3</b> Confirmar</span
          >
        </div>
        <v-card-text class="encaixe__corpo" :aria-busy="String(ocupado)">
          <v-alert v-if="erro" type="error" text dense role="alert">{{
            erro
          }}</v-alert>
          <div
            v-if="progresso"
            class="encaixe__progresso"
            role="status"
            aria-live="polite"
          >
            <div>
              <strong>{{ progresso.texto }}</strong
              ><span>{{ progresso.atual }} de {{ progresso.total }}</span>
            </div>
            <v-progress-linear
              :value="(100 * progresso.atual) / progresso.total"
              color="#5e72e4"
              height="5"
              rounded
              class="mt-2"
            />
          </div>
          <template v-if="etapa === 'SELECAO'">
            <div class="encaixe__secao-titulo">
              <h3>Quais pedidos você quer encaixar?</h3>
              <span>{{ selecionados.length }} selecionado(s)</span>
            </div>
            <v-row dense align="center">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="buscaPedidos"
                  label="Buscar por pedido, cliente, origem ou destino"
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  outlined
                  dense
                  hide-details
                  :disabled="ocupado"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3"
                ><v-switch
                  v-model="mostrarIndisponiveis"
                  label="Mostrar indisponíveis"
                  :disabled="ocupado"
                  hide-details
                  dense
                  class="mt-0"
              /></v-col>
              <v-col cols="12" sm="6" md="3" class="text-md-right">
                <v-btn
                  height="39"
                  class="
                    font-weight-bold
                    text-none
                    btn-ls btn-secondary
                    bg-gradient-light
                    px-4
                  "
                  :disabled="ocupado || !selecionados.length"
                  @click="selecionados = []"
                  ><v-icon left small>mdi-selection-remove</v-icon>Limpar
                  seleção</v-btn
                >
              </v-col>
            </v-row>
            <p class="encaixe__ajuda mt-3">
              Marque um ou vários pedidos. O quadrado no cabeçalho seleciona os
              pedidos disponíveis deste filtro.
            </p>
            <v-data-table
              :headers="headersPedidos"
              :items="pedidosFiltrados"
              :loading="carregando"
              item-key="id"
              :items-per-page="8"
              :footer-props="{
                'items-per-page-options': [8, 16, 32],
                'items-per-page-text': 'Pedidos por página',
              }"
              class="encaixe__tabela"
              no-data-text="Nenhum pedido encontrado. Tente outro filtro."
              loading-text="Carregando pedidos do dia…"
            >
              <template #header.selecao>
                <v-checkbox
                  :input-value="todosFiltradosSelecionados"
                  dense
                  hide-details
                  class="ma-0 pa-0"
                  :indeterminate="
                    algunsFiltradosSelecionados && !todosFiltradosSelecionados
                  "
                  :disabled="ocupado || !pedidosElegiveisFiltrados.length"
                  aria-label="Selecionar todos os pedidos disponíveis do filtro"
                  @change="selecionarFiltrados"
                />
              </template>
              <template #item.selecao="{ item }"
                ><v-checkbox
                  :input-value="selecionados.includes(item.id)"
                  dense
                  hide-details
                  class="ma-0 pa-0"
                  :disabled="ocupado || !item.elegivel"
                  :aria-label="`Selecionar pedido ${item.id}`"
                  @change="alternarPedido(item)"
              /></template>
              <template #item.id="{ item }"
                ><strong>#{{ item.id }}</strong></template
              >
              <template #item.origem="{ item }"
                ><strong>{{ item.origem || "—" }}</strong
                ><span class="encaixe__linha-secundaria">{{
                  item.destino
                    ? `Entrega: ${item.destino}`
                    : "Assistência no local"
                }}</span></template
              >
              <template #item.janelaOrigemInicio="{ item }">{{
                janela(item)
              }}</template>
              <template #item.elegivel="{ item }"
                ><span v-if="item.elegivel" class="encaixe__disponivel"
                  ><v-icon x-small color="#16804a">mdi-check-circle</v-icon>
                  Disponível</span
                ><span v-else class="encaixe__motivo">{{
                  item.motivo || "Pedido indisponível para encaixe"
                }}</span></template
              >
            </v-data-table>
            <p
              v-if="selecionadosForaFiltro"
              class="encaixe__ajuda mt-3"
              role="status"
            >
              {{ selecionadosForaFiltro }} pedido(s) selecionado(s) fora deste
              filtro. A seleção foi mantida.
            </p>
          </template>
          <template v-else>
            <div class="encaixe__resumo" aria-live="polite">
              <div>
                <strong>{{ itens.length }}</strong
                ><span>pedidos em revisão</span>
              </div>
              <div>
                <strong>{{ prontos.length }}</strong
                ><span>prontos para confirmar</span>
              </div>
              <div>
                <strong>{{ pendencias.length }}</strong
                ><span>aguardando ajuste</span>
              </div>
              <div class="encaixe__resumo-sucesso">
                <strong>{{ incluidos.length }}</strong
                ><span>incluídos</span>
              </div>
            </div>
            <v-alert
              v-if="confirmacaoConcluida"
              type="success"
              text
              role="status"
            >
              {{ incluidos.length }} pedido(s) incluído(s). Confira os roteiros
              e horários abaixo.
              <template v-if="!todosConfirmados"
                >Os pedidos desmarcados continuam pendentes.</template
              ></v-alert
            >
            <div v-else class="encaixe__orientacao">
              <v-icon small color="#5e72e4">mdi-information-outline</v-icon>
              <span
                >Use todas as sugestões ou escolha roteiro e hora prevista por
                pedido. Desmarque os pedidos que deseja deixar pendentes. Os
                horários são recalculados a cada inclusão, preservando a ordem
                dos atendimentos existentes e a equipe.</span
              >
            </div>
            <div v-if="!confirmacaoConcluida" class="encaixe__acoes-lote">
              <v-btn
                height="39"
                class="
                  font-weight-bold
                  text-none
                  btn-ls btn-secondary
                  bg-gradient-light
                  px-4
                "
                :disabled="ocupado || temIncerteza || !temSugestoes"
                @click="usarTodasSugestoes"
                ><v-icon left small>mdi-check-all</v-icon>Usar todas as
                sugestões</v-btn
              >
              <v-btn
                height="39"
                class="
                  font-weight-bold
                  text-none
                  btn-ls btn-secondary
                  bg-gradient-light
                  px-4
                "
                :disabled="ocupado || temIncerteza"
                @click="buscar"
                ><v-icon left small>mdi-refresh</v-icon>Recalcular
                pendentes</v-btn
              >
              <span class="encaixe__ajuda"
                >Sugestões priorizam menor distância e, depois, menor tempo
                adicional.</span
              >
            </div>
            <article
              v-for="item in itens"
              :key="item.pedido.id"
              class="encaixe-pedido"
              :class="{
                'encaixe-pedido--concluido': item.recibo,
                'encaixe-pedido--ignorado': !item.incluir && !item.recibo,
              }"
            >
              <div class="encaixe-pedido__cabecalho">
                <v-checkbox
                  v-if="!item.recibo"
                  v-model="item.incluir"
                  :disabled="ocupado || item.estado === 'INCERTO'"
                  :aria-label="`Incluir pedido ${item.pedido.id} na confirmação`"
                  hide-details
                  class="ma-0 pa-0"
                />
                <v-icon v-else color="#16804a">mdi-check-circle</v-icon>
                <div class="encaixe-pedido__identificacao">
                  <strong
                    >Pedido #{{ item.pedido.id }} ·
                    {{ item.pedido.cliente }}</strong
                  ><span
                    >{{ item.pedido.origem }}
                    <template v-if="item.pedido.destino"
                      >→ {{ item.pedido.destino }}</template
                    ><template v-else>· Assistência</template></span
                  >
                </div>
                <v-chip
                  small
                  :color="
                    item.recibo
                      ? '#e8f6ee'
                      : item.estado === 'PRONTO'
                      ? '#eef0ff'
                      : '#fff3df'
                  "
                  :text-color="
                    item.recibo
                      ? '#146c40'
                      : item.estado === 'PRONTO'
                      ? '#4050b5'
                      : '#8a5100'
                  "
                  >{{ estadoItem(item) }}</v-chip
                >
              </div>
              <div v-if="item.recibo" class="encaixe-pedido__recibo">
                Incluído no
                <strong
                  >roteiro {{ item.recibo.roteiro }} ·
                  {{ item.recibo.placa }}</strong
                ><span v-if="inicioPedido(item) != null">
                  · {{ horario(inicioPedido(item)) }}</span
                >
              </div>
              <template v-else-if="item.incluir">
                <v-alert
                  v-if="item.erro"
                  :type="item.estado === 'INCERTO' ? 'warning' : 'error'"
                  text
                  dense
                  class="mt-3 mb-2"
                  role="alert"
                  >{{ item.erro }}</v-alert
                >
                <template v-if="item.estado !== 'INCERTO'">
                  <v-radio-group
                    v-model="item.modo"
                    row
                    hide-details
                    :disabled="ocupado"
                    class="mt-3 mb-3"
                    @change="alterarModo(item)"
                  >
                    <v-radio
                      value="SUGESTAO"
                      label="Usar sugestão"
                      :disabled="!item.sugestoes?.opcoes.length"
                    />
                    <v-radio
                      value="MANUAL"
                      label="Escolher roteiro e hora prevista"
                    />
                  </v-radio-group>
                  <v-row v-if="item.modo === 'MANUAL'" dense align="start">
                    <v-col cols="12" md="5"
                      ><v-autocomplete
                        v-model="item.roteiroId"
                        :items="roteiros"
                        item-text="rotulo"
                        item-value="roteiroId"
                        label="Roteiro do dia"
                        outlined
                        dense
                        hide-details="auto"
                        :disabled="ocupado"
                        :error="!item.roteiroId"
                        no-data-text="Nenhum roteiro ativo disponível"
                        @change="invalidarAjuste(item)"
                    /></v-col>
                    <v-col cols="12" sm="6" md="3"
                      ><v-text-field
                        v-model="item.horario"
                        type="time"
                        label="Hora prevista da coleta / assistência"
                        outlined
                        dense
                        hide-details="auto"
                        :disabled="ocupado"
                        :error="!horarioValido(item.horario)"
                        @input="invalidarAjuste(item)"
                    /></v-col>
                    <v-col cols="12" sm="6" md="4"
                      ><v-btn
                        height="39"
                        class="
                          font-weight-bold
                          text-none
                          btn-primary
                          bg-gradient-primary
                          px-4
                        "
                        :loading="calculando && item.estado === 'CALCULANDO'"
                        :disabled="
                          ocupado ||
                          !item.roteiroId ||
                          !horarioValido(item.horario)
                        "
                        @click="validarItem(item)"
                        ><v-icon left small>mdi-check-decagram-outline</v-icon
                        >Validar escolha</v-btn
                      ></v-col
                    >
                    <v-col cols="12"
                      ><p class="encaixe__ajuda mb-2">
                        Informe o início da coleta ou assistência. A entrega e
                        os demais horários serão calculados respeitando as
                        janelas do pedido, a jornada e os limites do veículo.
                      </p>
                      <p v-if="erroRoteiros" class="encaixe__motivo">
                        {{ erroRoteiros }}
                        <v-btn
                          small
                          class="
                            text-none
                            btn-ls btn-secondary
                            bg-gradient-light
                          "
                          :disabled="ocupado"
                          @click="carregarRoteiros"
                          >Recarregar roteiros</v-btn
                        >
                      </p></v-col
                    >
                  </v-row>
                </template>
                <div v-if="opcao(item)" class="encaixe-pedido__sugestao">
                  <div>
                    <span class="encaixe__rotulo">{{
                      item.modo === "MANUAL"
                        ? "ESCOLHA VALIDADA"
                        : "MELHOR ENCAIXE"
                    }}</span
                    ><strong
                      >Roteiro {{ opcao(item).roteiro }} ·
                      {{ opcao(item).placa }}</strong
                    ><span
                      >{{ horario(inicioPedido(item))
                      }}<template v-if="entregaPedido(item) != null">
                        · Entrega {{ horario(entregaPedido(item)) }}</template
                      ></span
                    >
                  </div>
                  <div class="encaixe-pedido__metricas">
                    <span
                      ><strong
                        >{{
                          numero(opcao(item).resultado.kmAdicionais)
                        }}
                        km</strong
                      >
                      adicionais</span
                    ><span
                      ><strong
                        >{{
                          numero(opcao(item).resultado.minutosAdicionais)
                        }}
                        min</strong
                      >
                      adicionais</span
                    ><span
                      >Retorno
                      {{ horario(opcao(item).resultado.retornoSegundos) }}</span
                    >
                  </div>
                  <v-btn
                    height="39"
                    class="
                      font-weight-bold
                      text-none
                      btn-ls btn-secondary
                      bg-gradient-light
                      px-4
                    "
                    :disabled="ocupado"
                    :aria-expanded="String(detalhesId === item.pedido.id)"
                    @click="
                      detalhesId =
                        detalhesId === item.pedido.id ? null : item.pedido.id
                    "
                    ><v-icon left small>mdi-format-list-bulleted</v-icon
                    >{{
                      detalhesId === item.pedido.id
                        ? "Ocultar paradas"
                        : "Ver paradas"
                    }}</v-btn
                  >
                </div>
                <p
                  v-else-if="!item.erro && item.estado !== 'CALCULANDO'"
                  class="encaixe__motivo mt-2"
                >
                  {{
                    item.modo === "MANUAL"
                      ? "Valide o roteiro e a hora prevista para continuar."
                      : "Nenhuma sugestão viável. Escolha um roteiro e horário para avaliar outra possibilidade."
                  }}
                </p>
                <v-expand-transition
                  ><div
                    v-if="detalhesId === item.pedido.id && opcao(item)"
                    class="mt-3"
                  >
                    <v-data-table
                      :headers="headersParadas"
                      :items="paradas(item)"
                      item-key="no"
                      :items-per-page="-1"
                      hide-default-footer
                      dense
                      class="encaixe__tabela"
                      ><template #item.pedido="{ item: parada }"
                        >#{{ parada.pedido }}
                        <v-chip
                          v-if="parada.pedido === item.pedido.id"
                          x-small
                          color="#eef0ff"
                          text-color="#4050b5"
                          >Novo pedido</v-chip
                        ></template
                      ><template #item.inicioSegundos="{ item: parada }">{{
                        horario(parada.inicioSegundos)
                      }}</template></v-data-table
                    >
                  </div></v-expand-transition
                >
                <v-expansion-panels
                  v-if="item.sugestoes?.indisponiveis.length"
                  flat
                  class="encaixe__indisponiveis mt-2"
                  ><v-expansion-panel
                    ><v-expansion-panel-header
                      >Por que outros roteiros não foram sugeridos? ({{
                        item.sugestoes.indisponiveis.length
                      }})</v-expansion-panel-header
                    ><v-expansion-panel-content
                      ><p
                        v-for="indisponivel in item.sugestoes.indisponiveis"
                        :key="indisponivel.roteiroId"
                        class="mb-2"
                      >
                        Roteiro {{ nomeRoteiro(indisponivel.roteiroId) }}:
                        {{ indisponivel.motivo }}
                      </p></v-expansion-panel-content
                    ></v-expansion-panel
                  ></v-expansion-panels
                >
              </template>
              <p v-else class="encaixe__ajuda mt-3 mb-0">
                Este pedido continuará pendente. Marque-o novamente para revisar
                e incluir.
              </p>
            </article>
          </template>
          <v-alert
            v-if="!podeAprovar && etapa === 'REVISAO'"
            type="info"
            text
            dense
            class="mt-4"
            >Seu acesso permite consultar os encaixes. A confirmação exige
            permissão para alterar pedidos, roteiros e trajetos e inserir
            trajetos.</v-alert
          >
        </v-card-text>
        <v-card-actions class="crud-form-actions encaixe__rodape">
          <div class="encaixe__rodape-texto" role="status" aria-live="polite">
            <template v-if="etapa === 'SELECAO'"
              ><strong
                >{{ selecionados.length }} pedido(s) selecionado(s)</strong
              ><span
                >As sugestões serão apresentadas antes da confirmação.</span
              ></template
            ><template v-else
              ><strong
                >{{ incluidos.length }} incluído(s) ·
                {{ aConfirmar.length }} selecionado(s) para confirmar</strong
              ><span v-if="pendencias.length"
                >Ajuste ou desmarque {{ pendencias.length }} pedido(s) para
                continuar.</span
              ><span v-else-if="!confirmacaoConcluida"
                >A confirmação inclui somente os pedidos marcados.</span
              ></template
            >
          </div>
          <div class="encaixe__rodape-acoes">
            <v-btn
              v-if="etapa === 'REVISAO' && !incluidos.length"
              height="39"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-ls btn-secondary
                bg-gradient-light
                px-4
              "
              :disabled="ocupado || temIncerteza"
              @click="voltarSelecao"
              ><v-icon left small>mdi-arrow-left</v-icon>Alterar pedidos</v-btn
            >
            <v-btn
              height="39"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-ls btn-secondary
                bg-gradient-light
                px-4
              "
              :disabled="confirmando"
              @click="fechar"
              >Fechar</v-btn
            >
            <v-btn
              v-if="etapa === 'SELECAO'"
              height="39"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                px-6
                ms-3
              "
              :loading="calculando"
              :disabled="ocupado || !selecionados.length || !diaAtual"
              @click="buscar"
              ><v-icon left small>mdi-auto-fix</v-icon>Buscar encaixes ({{
                selecionados.length
              }})</v-btn
            >
            <v-btn
              v-else-if="confirmacaoConcluida"
              height="39"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                px-6
                ms-3
              "
              @click="abrir"
              ><v-icon left small>mdi-plus</v-icon>Encaixar outros
              pedidos</v-btn
            >
            <v-btn
              v-else
              height="39"
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                px-6
                ms-3
              "
              :loading="confirmando"
              :disabled="!podeConfirmar"
              @click="confirmar"
              ><v-icon left small>mdi-check-all</v-icon
              >{{
                temIncerteza
                  ? "Retomar confirmação"
                  : `Confirmar encaixes (${aConfirmar.length})`
              }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import DataService from "@/services/ComumDataService";
const url = "/roteirizador/pedidos";
export default {
  name: "EncaixarPedidoDia",
  props: {
    obterData: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      data: "",
      pedidos: [],
      selecionados: [],
      buscaPedidos: "",
      mostrarIndisponiveis: false,
      etapa: "SELECAO",
      itens: [],
      roteiros: [],
      erro: "",
      erroRoteiros: "",
      carregando: false,
      calculando: false,
      confirmando: false,
      progresso: null,
      detalhesId: null,
      token: 0,
      headersPedidos: [
        { text: "", value: "selecao", sortable: false, width: 48 },
        { text: "Pedido", value: "id", width: 100 },
        { text: "Cliente", value: "cliente" },
        { text: "Origem e destino", value: "origem" },
        {
          text: "Janela da coleta / assistência",
          value: "janelaOrigemInicio",
          sortable: false,
        },
        { text: "Situação", value: "elegivel", sortable: false },
      ],
      headersParadas: [
        { text: "Pedido", value: "pedido", sortable: false },
        { text: "Atendimento", value: "tipo", sortable: false },
        { text: "Local", value: "descricao", sortable: false },
        { text: "Nova previsão", value: "inicioSegundos", sortable: false },
      ],
    };
  },
  computed: {
    tenantId() {
      return this.$store.state.inquilino?.id;
    },
    permissoes() {
      return this.$store.state.permissoes || [];
    },
    podePlanejar() {
      return ["Roteirizador_PlanejamentoRotas", "Pedido_List"].every((p) =>
        this.permissoes.includes(`ROLE_${p}`)
      );
    },
    podeAprovar() {
      return [
        "Pedido_Update",
        "Roteiro_Update",
        "RoteiroTrajeto_Insert",
        "RoteiroTrajeto_Update",
      ].every((p) => this.permissoes.includes(`ROLE_${p}`));
    },
    ocupado() {
      return this.carregando || this.calculando || this.confirmando;
    },
    diaAtual() {
      return (
        this.data ===
        new Intl.DateTimeFormat("sv-SE", {
          timeZone: "America/Sao_Paulo",
        }).format(new Date())
      );
    },
    dataFormatada() {
      return this.data.split("-").reverse().join("/");
    },
    pedidosFiltrados() {
      const query = this.normalizar(this.buscaPedidos);
      return this.pedidos.filter(
        (p) =>
          (this.mostrarIndisponiveis || p.elegivel) &&
          (!query ||
            this.normalizar(
              [p.id, p.cliente, p.origem, p.destino, p.motivo].join(" ")
            ).includes(query))
      );
    },
    pedidosElegiveisFiltrados() {
      return this.pedidosFiltrados.filter((p) => p.elegivel);
    },
    todosFiltradosSelecionados() {
      return (
        this.pedidosElegiveisFiltrados.length > 0 &&
        this.pedidosElegiveisFiltrados.every((p) =>
          this.selecionados.includes(p.id)
        )
      );
    },
    algunsFiltradosSelecionados() {
      return this.pedidosElegiveisFiltrados.some((p) =>
        this.selecionados.includes(p.id)
      );
    },
    selecionadosForaFiltro() {
      const ids = new Set(this.pedidosFiltrados.map((p) => p.id));
      return this.selecionados.filter((id) => !ids.has(id)).length;
    },
    incluidos() {
      return this.itens.filter((item) => item.recibo);
    },
    aConfirmar() {
      return this.itens.filter((item) => item.incluir && !item.recibo);
    },
    prontos() {
      return this.aConfirmar.filter((item) => this.itemPronto(item));
    },
    pendencias() {
      return this.aConfirmar.filter((item) => !this.itemPronto(item));
    },
    temSugestoes() {
      return this.itens.some(
        (item) => !item.recibo && item.sugestoes?.opcoes.length
      );
    },
    temIncerteza() {
      return this.itens.some((item) => item.estado === "INCERTO");
    },
    todosConfirmados() {
      return (
        this.itens.length > 0 && this.incluidos.length === this.itens.length
      );
    },
    confirmacaoConcluida() {
      return this.incluidos.length > 0 && !this.aConfirmar.length;
    },
    podeConfirmar() {
      return (
        !this.ocupado &&
        this.podeAprovar &&
        this.diaAtual &&
        this.aConfirmar.length > 0 &&
        (this.temIncerteza || !this.pendencias.length)
      );
    },
  },
  watch: {
    tenantId() {
      this.fechar();
    },
  },
  beforeDestroy() {
    this.token++;
  },
  deactivated() {
    this.fechar();
  },
  methods: {
    atual(token, tenant) {
      return token === this.token && tenant === this.tenantId;
    },
    normalizar(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    mensagem(e) {
      return (
        e.response?.data?.message ||
        e.message ||
        "Não foi possível concluir o encaixe."
      );
    },
    numero(n) {
      return Number(n || 0).toLocaleString("pt-BR", {
        maximumFractionDigits: 1,
      });
    },
    horario(seconds) {
      if (seconds == null || !Number.isFinite(Number(seconds))) return "—";
      const d = new Date(`${this.data}T00:00:00Z`);
      d.setUTCSeconds(seconds);
      return `${String(d.getUTCDate()).padStart(2, "0")}/${String(
        d.getUTCMonth() + 1
      ).padStart(2, "0")} ${String(d.getUTCHours()).padStart(2, "0")}:${String(
        d.getUTCMinutes()
      ).padStart(2, "0")}`;
    },
    janela(pedido) {
      return (
        [pedido.janelaOrigemInicio, pedido.janelaOrigemFinal]
          .filter(Boolean)
          .map((h) => String(h).slice(0, 5))
          .join(" – ") || "Não informada"
      );
    },
    horarioValido(horario) {
      return /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(horario || "");
    },
    opcao(item) {
      return (
        item.previa?.opcoes.find((o) => o.roteiroId === item.roteiroId) || null
      );
    },
    paradas(item) {
      return (this.opcao(item)?.resultado?.paradas || []).filter(
        (p) => p.tipo !== "CONCLUSAO_ASSISTENCIA"
      );
    },
    inicioPedido(item) {
      return (
        item.recibo?.inicioSegundos ??
        this.paradas(item).find(
          (p) => p.pedido === item.pedido.id && p.tipo !== "ENTREGA"
        )?.inicioSegundos
      );
    },
    entregaPedido(item) {
      return (
        item.recibo?.entregaSegundos ??
        this.paradas(item).find(
          (p) => p.pedido === item.pedido.id && p.tipo === "ENTREGA"
        )?.inicioSegundos
      );
    },
    nomeRoteiro(id) {
      return this.roteiros.find((r) => r.roteiroId === id)?.roteiro ?? `#${id}`;
    },
    itemPronto(item) {
      return (
        item.estado === "INCERTO" ||
        (item.estado === "PRONTO" && !!this.opcao(item))
      );
    },
    estadoItem(item) {
      if (item.recibo) return "Incluído";
      if (!item.incluir) return "Fica pendente";
      return (
        {
          AGUARDANDO: "Aguardando revisão",
          CALCULANDO: "Calculando…",
          PRONTO: "Pronto para confirmar",
          ERRO: "Revisar escolha",
          INCERTO: "Retomar confirmação",
        }[item.estado] || "Aguardando revisão"
      );
    },
    alternarPedido(pedido) {
      if (this.ocupado || !pedido.elegivel) return;
      this.selecionados = this.selecionados.includes(pedido.id)
        ? this.selecionados.filter((id) => id !== pedido.id)
        : [...this.selecionados, pedido.id];
    },
    selecionarFiltrados() {
      if (this.ocupado) return;
      const ids = new Set(this.pedidosElegiveisFiltrados.map((p) => p.id));
      this.selecionados = this.todosFiltradosSelecionados
        ? this.selecionados.filter((id) => !ids.has(id))
        : [...new Set([...this.selecionados, ...ids])];
    },
    fechar() {
      this.token++;
      this.dialog = false;
      this.carregando = this.calculando = this.confirmando = false;
      this.pedidos = [];
      this.selecionados = [];
      this.itens = [];
      this.roteiros = [];
      this.erro = this.erroRoteiros = this.buscaPedidos = "";
      this.progresso = null;
      this.detalhesId = null;
      this.etapa = "SELECAO";
    },
    async carregarRoteiros() {
      const token = this.token,
        tenant = this.tenantId;
      try {
        const { data } = await DataService.get(`${url}/encaixes/roteiros`);
        if (!this.atual(token, tenant)) return;
        this.roteiros = (Array.isArray(data) ? data : []).map((r) => ({
          ...r,
          rotulo: `Roteiro ${r.roteiro} · ${r.placa || "Sem veículo"}`,
        }));
        this.erroRoteiros = "";
      } catch (e) {
        if (this.atual(token, tenant))
          this.erroRoteiros = `Não foi possível carregar os roteiros. ${this.mensagem(
            e
          )}`;
      }
    },
    async abrir() {
      this.fechar();
      this.dialog = true;
      this.mostrarIndisponiveis = false;
      this.data =
        this.obterData() ||
        new Intl.DateTimeFormat("sv-SE", {
          timeZone: "America/Sao_Paulo",
        }).format(new Date());
      if (!this.diaAtual) {
        this.erro =
          "Selecione a data de hoje na listagem para encaixar pedidos do dia.";
        return;
      }
      const token = this.token,
        tenant = this.tenantId;
      this.carregando = true;
      const routes = this.carregarRoteiros();
      try {
        const { data } = await DataService.get(url, {
          params: { data: this.data },
        });
        if (!this.atual(token, tenant)) return;
        this.pedidos = (Array.isArray(data) ? data : []).map((p) => ({
          ...p,
          indisponivel: !p.elegivel,
        }));
      } catch (e) {
        if (this.atual(token, tenant)) this.erro = this.mensagem(e);
      } finally {
        await routes;
        if (this.atual(token, tenant)) this.carregando = false;
      }
    },
    criarItem(pedido) {
      return {
        pedido,
        incluir: true,
        modo: "SUGESTAO",
        sugestoes: null,
        previa: null,
        roteiroId: null,
        horario: "",
        recibo: null,
        estado: "AGUARDANDO",
        erro: "",
        desatualizado: false,
      };
    },
    voltarSelecao() {
      if (this.ocupado || this.temIncerteza || this.incluidos.length) return;
      this.etapa = "SELECAO";
      this.itens = [];
      this.erro = "";
    },
    usarSugestao(item) {
      item.modo = "SUGESTAO";
      item.previa = item.sugestoes;
      item.roteiroId = item.sugestoes?.opcoes[0]?.roteiroId || null;
      item.horario = "";
      item.erro = "";
      item.estado = this.opcao(item) ? "PRONTO" : "AGUARDANDO";
    },
    usarTodasSugestoes() {
      if (this.ocupado || this.temIncerteza) return;
      this.itens
        .filter((item) => !item.recibo && item.sugestoes?.opcoes.length)
        .forEach((item) => {
          item.incluir = true;
          this.usarSugestao(item);
        });
    },
    alterarModo(item) {
      if (item.modo === "SUGESTAO") {
        this.usarSugestao(item);
        return;
      }
      const inicio = this.inicioPedido(item);
      const minutos = Math.ceil(inicio / 60);
      if (inicio != null && minutos < 1440)
        item.horario = `${String(Math.floor(minutos / 60)).padStart(
          2,
          "0"
        )}:${String(minutos % 60).padStart(2, "0")}`;
      this.invalidarAjuste(item);
    },
    invalidarAjuste(item) {
      item.previa = null;
      item.erro = "";
      item.estado = "AGUARDANDO";
    },
    async calcularItem(item, { atualizar = false } = {}) {
      const token = this.token,
        tenant = this.tenantId;
      const body = { pedido: item.pedido.id };
      if (item.modo === "MANUAL") {
        if (!item.roteiroId || !this.horarioValido(item.horario)) {
          item.erro = "Escolha o roteiro e uma hora prevista válida.";
          item.estado = "ERRO";
          return false;
        }
        body.roteiroId = item.roteiroId;
        body.horario = item.horario;
      } else if (atualizar && item.roteiroId) body.roteiroId = item.roteiroId;
      item.estado = "CALCULANDO";
      item.erro = "";
      item.previa = null;
      try {
        const { data } = await DataService.post(`${url}/encaixes`, body);
        if (!this.atual(token, tenant)) return false;
        const previa = {
          ...data,
          opcoes: data.opcoes || [],
          indisponiveis: data.indisponiveis || [],
        };
        item.previa = previa;
        if (item.modo === "SUGESTAO") {
          item.sugestoes = previa;
          item.roteiroId =
            previa.opcoes[0]?.roteiroId || body.roteiroId || null;
        }
        if (!this.opcao(item)) {
          item.erro =
            previa.indisponiveis
              .map(
                (r) => `Roteiro ${this.nomeRoteiro(r.roteiroId)}: ${r.motivo}`
              )
              .join(" · ") ||
            "Nenhum encaixe viável. Escolha outro roteiro ou horário, ou deixe este pedido pendente.";
          item.estado = "ERRO";
          return false;
        }
        item.estado = "PRONTO";
        item.desatualizado = false;
        return true;
      } catch (e) {
        if (this.atual(token, tenant)) {
          item.erro = this.mensagem(e);
          item.estado = "ERRO";
        }
        return false;
      }
    },
    async buscar() {
      if (this.ocupado || !this.diaAtual || this.temIncerteza) return;
      if (this.etapa === "SELECAO") {
        const ids = new Set(this.selecionados);
        this.itens = this.pedidos
          .filter((p) => p.elegivel && ids.has(p.id))
          .map(this.criarItem);
        if (!this.itens.length) return;
        this.etapa = "REVISAO";
      }
      this.erro = "";
      this.calculando = true;
      const token = this.token,
        tenant = this.tenantId;
      const items = this.itens.filter((item) => !item.recibo && item.incluir);
      try {
        for (let i = 0; i < items.length; i++) {
          if (!this.atual(token, tenant)) return;
          this.progresso = {
            atual: i + 1,
            total: items.length,
            texto: `Calculando pedido #${items[i].pedido.id}`,
          };
          await this.calcularItem(items[i]);
        }
      } finally {
        if (this.atual(token, tenant)) {
          this.calculando = false;
          this.progresso = null;
        }
      }
    },
    async validarItem(item) {
      if (
        this.ocupado ||
        item.recibo ||
        item.estado === "INCERTO" ||
        !this.diaAtual
      )
        return;
      this.calculando = true;
      const token = this.token,
        tenant = this.tenantId;
      try {
        await this.calcularItem(item);
      } finally {
        if (this.atual(token, tenant)) this.calculando = false;
      }
    },
    async confirmar() {
      if (!this.podeConfirmar) return;
      this.erro = "";
      this.confirmando = true;
      const token = this.token,
        tenant = this.tenantId,
        antes = this.incluidos.length;
      const items = this.temIncerteza
        ? [
            ...this.aConfirmar.filter((item) => item.estado === "INCERTO"),
            ...this.prontos.filter((item) => item.estado !== "INCERTO"),
          ]
        : [...this.aConfirmar];
      try {
        for (let i = 0; i < items.length; i++) {
          if (!this.atual(token, tenant)) return;
          const item = items[i];
          this.progresso = {
            atual: i + 1,
            total: items.length,
            texto: `Confirmando pedido #${item.pedido.id}`,
          };
          // Uma confirmação altera o estado operacional. Recalcula os próximos
          // pedidos no roteiro já escolhido, sem trocar a decisão do usuário.
          if (
            item.desatualizado &&
            item.estado !== "INCERTO" &&
            !(await this.calcularItem(item, { atualizar: true }))
          )
            continue;
          if (!this.atual(token, tenant)) return;
          try {
            const { data } = await DataService.post(
              `${url}/encaixes/${item.previa.id}/aprovacao`,
              { roteiroId: item.roteiroId }
            );
            if (!this.atual(token, tenant)) return;
            item.recibo = data;
            item.estado = "CONFIRMADO";
            item.erro = "";
            this.itens
              .filter((other) => !other.recibo)
              .forEach((other) => {
                other.desatualizado = true;
              });
          } catch (e) {
            if (!this.atual(token, tenant)) return;
            const status = e.response?.status;
            if (!status || status >= 500 || status === 408) {
              item.estado = "INCERTO";
              item.erro =
                "A conexão foi interrompida durante a confirmação. Use Retomar confirmação para consultar o resultado sem duplicar o pedido.";
              break;
            }
            item.estado = "ERRO";
            item.erro = this.mensagem(e);
            if (status === 409) {
              item.previa = null;
              item.desatualizado = true;
            }
          }
        }
      } finally {
        if (this.atual(token, tenant)) {
          this.confirmando = false;
          this.progresso = null;
          if (this.incluidos.length > antes)
            this.$emit(
              "gerado",
              this.incluidos.map((item) => item.recibo)
            );
        }
      }
    },
  },
};
</script>

<style scoped>
.encaixe {
  color: #344767;
  border-radius: 14px !important;
}
.encaixe__cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 22px 24px 16px;
}
.encaixe__titulo {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.encaixe__titulo h2 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #25324b;
  margin: 3px 0 4px;
  line-height: 1.35;
}
.encaixe__titulo p {
  color: #667085;
  margin: 0;
  font-size: 0.85rem;
}
.encaixe__rotulo {
  display: block;
  color: #667085;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.06em;
}
.encaixe__etapas {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 24px;
  border-top: 1px solid #edf0f5;
  border-bottom: 1px solid #edf0f5;
  background: #f8f9fd;
}
.encaixe__etapas > span {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.8rem;
  color: #667085;
}
.encaixe__etapas b {
  display: grid;
  place-items: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #e9ecf4;
}
.encaixe__etapas .encaixe__etapa--ativa {
  color: #4050b5;
  font-weight: 700;
}
.encaixe__etapa--ativa b {
  background: #5e72e4;
  color: white;
}
.encaixe__corpo {
  padding: 22px 24px !important;
}
.encaixe__secao-titulo {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
  align-items: center;
}
.encaixe__secao-titulo h3 {
  color: #344767;
  font-size: 1rem;
}
.encaixe__secao-titulo > span {
  color: #4050b5;
  font-weight: 700;
}
.encaixe__ajuda {
  color: #667085;
  font-size: 0.78rem;
  line-height: 1.5;
}
.encaixe__linha-secundaria {
  display: block;
  color: #667085;
  font-size: 0.76rem;
  margin-top: 4px;
}
.encaixe__disponivel {
  color: #16804a;
  font-size: 0.78rem;
  white-space: nowrap;
}
.encaixe__motivo {
  color: #8a5100;
  font-size: 0.8rem;
  line-height: 1.5;
}
.encaixe__tabela {
  border: 1px solid #e6e9f1;
  border-radius: 8px;
  overflow: hidden;
}
.encaixe__tabela ::v-deep th {
  background: #f8f9fd;
  color: #475467 !important;
}
.encaixe__tabela ::v-deep td {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.encaixe__resumo {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 1px solid #e6e9f1;
  border-radius: 10px;
  margin-bottom: 18px;
  overflow: hidden;
}
.encaixe__resumo > div {
  display: flex;
  flex-direction: column;
  padding: 12px 18px;
  border-right: 1px solid #e6e9f1;
}
.encaixe__resumo > div:last-child {
  border-right: 0;
}
.encaixe__resumo strong {
  font-size: 1.5rem;
  color: #344767;
  line-height: 1.4;
}
.encaixe__resumo span {
  color: #667085;
  font-size: 0.76rem;
}
.encaixe__resumo .encaixe__resumo-sucesso {
  background: #f2faf5;
}
.encaixe__resumo-sucesso strong {
  color: #16804a;
}
.encaixe__orientacao {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #475467;
  background: #f5f6ff;
  border: 1px solid #e4e7ff;
  border-radius: 8px;
  padding: 12px;
  font-size: 0.8rem;
  line-height: 1.5;
  margin-bottom: 16px;
}
.encaixe__orientacao .v-icon {
  margin-top: 2px;
}
.encaixe__acoes-lote {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.encaixe-pedido {
  padding: 16px;
  border: 1px solid #e0e5f0;
  border-radius: 10px;
  margin-top: 14px;
  background: white;
}
.encaixe-pedido--concluido {
  border-color: #bde3cb;
  background: #fbfefc;
}
.encaixe-pedido--ignorado {
  background: #f8f9fb;
}
.encaixe-pedido__cabecalho {
  display: flex;
  align-items: center;
  gap: 12px;
}
.encaixe-pedido__identificacao {
  flex: 1;
  min-width: 0;
}
.encaixe-pedido__identificacao > strong {
  color: #344767;
  font-size: 0.9rem;
}
.encaixe-pedido__identificacao > span {
  display: block;
  color: #667085;
  font-size: 0.78rem;
  margin-top: 3px;
}
.encaixe-pedido__sugestao {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  padding: 14px;
  background: #f7f8fe;
  border-radius: 8px;
}
.encaixe-pedido__sugestao > div:first-child {
  flex: 1;
  min-width: 180px;
}
.encaixe-pedido__sugestao > div:first-child > strong {
  display: block;
  color: #344767;
  margin: 3px 0;
}
.encaixe-pedido__sugestao > div:first-child > span:last-child {
  color: #475467;
  font-size: 0.8rem;
}
.encaixe-pedido__metricas {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 0.78rem;
  color: #667085;
}
.encaixe-pedido__metricas strong {
  color: #344767;
}
.encaixe-pedido__recibo {
  margin: 12px 0 0 36px;
  color: #146c40;
  font-size: 0.85rem;
}
.encaixe__indisponiveis ::v-deep .v-expansion-panel-header {
  padding: 12px 0;
  min-height: 44px;
  color: #667085;
  font-size: 0.78rem;
}
.encaixe__progresso {
  padding: 14px;
  border-radius: 8px;
  background: #f5f6ff;
  margin-bottom: 18px;
}
.encaixe__progresso > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #4050b5;
  font-size: 0.82rem;
}
.encaixe__rodape {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  border-top: 1px solid #e6e9f1;
  padding: 16px 24px !important;
  background: #fafbfe;
}
.encaixe__rodape-texto {
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;
  color: #344767;
  flex: 1;
  min-width: 220px;
}
.encaixe__rodape-texto > span {
  color: #667085;
  font-size: 0.75rem;
  margin-top: 3px;
}
.encaixe__rodape-acoes {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.encaixe .btn-primary,
.encaixe .btn-secondary {
  letter-spacing: 0;
  border-radius: 8px;
}
.encaixe .btn-primary:not(.v-btn--disabled) {
  color: #fff !important;
}
.encaixe .btn-secondary:not(.v-btn--disabled) {
  color: #344767 !important;
}
.encaixe .btn-primary.v-btn--disabled,
.encaixe .btn-secondary.v-btn--disabled {
  background: #edf0f5 !important;
  color: #667085 !important;
  box-shadow: none !important;
}
.encaixe .v-btn:focus-visible {
  outline: 2px solid #5e72e4;
  outline-offset: 3px;
}
.encaixe .btn-primary ::v-deep .v-icon,
.encaixe .btn-secondary ::v-deep .v-icon {
  color: inherit !important;
}
@media (max-width: 600px) {
  .encaixe__cabecalho {
    padding: 16px;
  }
  .encaixe__titulo {
    gap: 8px;
    align-items: flex-start;
  }
  .encaixe__titulo .crud-form-heading__icon {
    display: none;
  }
  .encaixe__titulo h2 {
    font-size: 1.1rem;
  }
  .encaixe__etapas {
    padding: 12px 16px;
    gap: 6px;
  }
  .encaixe__etapas > span {
    font-size: 0.68rem;
    gap: 4px;
  }
  .encaixe__etapas b {
    width: 20px;
    height: 20px;
  }
  .encaixe__corpo {
    padding: 16px !important;
  }
  .encaixe__resumo {
    grid-template-columns: repeat(2, 1fr);
  }
  .encaixe__resumo > div {
    padding: 10px 12px;
    border-bottom: 1px solid #e6e9f1;
  }
  .encaixe-pedido {
    padding: 12px;
  }
  .encaixe-pedido__cabecalho {
    flex-wrap: wrap;
    gap: 8px;
  }
  .encaixe-pedido__cabecalho .v-chip {
    margin-left: 32px;
  }
  .encaixe-pedido__identificacao {
    flex-basis: calc(100% - 40px);
  }
  .encaixe-pedido__sugestao {
    padding: 12px;
    gap: 12px;
  }
  .encaixe-pedido__sugestao > .v-btn {
    width: 100%;
  }
  .encaixe__rodape {
    padding: 12px 16px !important;
  }
  .encaixe__rodape-acoes {
    width: 100%;
  }
  .encaixe__rodape-acoes > .v-btn {
    flex: 1 1 auto;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
